import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

export const getAllSubDCA = () => get('/Accounts/GetAllSubDCA', {}, 'Failed to fetch sub account heads');
export const getItCodesLookup = () => get('/Accounts/GetITCodes', {}, 'Failed to fetch IT codes');
export const getApprovalStatusSDCA = (CheckType, ROID) =>
    get('/Accounts/GetapprstatusSDCA', { CheckType, ROID }, 'Failed to fetch allowed actions');

export const updateSubDCA = (payload) => put('/Accounts/UpdateSubDCA', payload, 'Failed to update sub account head');
